import {
	useDispatch,
	useSelector,
} from 'react-redux'

import {
	getOnboardingPipelineTriggers,
	getOnboardingPipelines,
	getProspectiveClients,
	prospectSelectors,
	pipelineSelectors,
	setProspectViewer,
	toggleCreator
} from './slice'

export const useProspectiveClientIds = ()=>{
	const dispatch = useDispatch()
	const {status} = useSelector(state=>state.growth.prospects)
	const ids = useSelector(prospectSelectors.selectIds)

	if (status==='init') dispatch(getProspectiveClients())

	return {status,ids}
}

export const useProspectiveClients = ()=>{
	const dispatch = useDispatch()
	const {status,entities} = useSelector(state=>state.growth.prospects)
	const prospects = useSelector(prospectSelectors.selectAll)

	if (status==='init') dispatch(getProspectiveClients())

	return {status,prospects,entities}
}

export const useProspectiveClient = (id)=>{
	const dispatch = useDispatch()
	const {status} = useSelector(state=>state.growth.prospects)

	if (status==='init') dispatch(getProspectiveClients())

	const prospect = useSelector(state=>prospectSelectors.selectById(state,id))

	return {status,prospect}
}

export const useOnboardingPipelines = ()=>{
	const dispatch = useDispatch()
	const {status} = useSelector(state=>state.growth.pipelines)
	const pipelines = useSelector(pipelineSelectors.selectAll)

	if (status==='init') dispatch(getOnboardingPipelines())

	return {status,pipelines}
}

export const useOnboardingPipelineTriggers = ()=>{
	const dispatch = useDispatch()
	const {status,list:triggers} = useSelector(state=>state.growth.pipelines.triggers)

	if (status==='init') dispatch(getOnboardingPipelineTriggers())

	return {status,triggers}
}

export const useOnboardingPipeline = (id)=>{
	const dispatch = useDispatch()
	const {status} = useSelector(state=>state.growth.pipelines)

	if (status==='init') dispatch(getOnboardingPipelines())

	const pipeline = useSelector(state=>pipelineSelectors.selectById(state,id))

	return {status,pipeline}
}

export const useProspectViewer = ()=>useSelector(state=>state.growth.prospects.viewer)

export const useSetProspectViewer = ()=>{
	const dispatch = useDispatch()
	return (payload)=>{
		dispatch(setProspectViewer(payload))
	}
}

export const useCreator = ()=> useSelector(state=>state.growth.prospects.creator)

export const useToggleCreator = ()=>{
	const dispatch = useDispatch()
	return ()=>{
		dispatch(toggleCreator())
	}
}

export const useHasCRM = ()=>(
	useSelector(
		state => state.growth.hasCRM
	)
)


